import { render } from "./SkipLinks.vue?vue&type=template&id=4c63d358&scoped=true"
import script from "./SkipLinks.vue?vue&type=script&lang=js"
export * from "./SkipLinks.vue?vue&type=script&lang=js"

import "./SkipLinks.vue?vue&type=style&index=0&id=4c63d358&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c63d358"]])

export default __exports__